HImageCropperComponent.$inject = ['$scope', '$element', '$timeout', 'userMedia', '$filter', 'deviceChecker'];

function HImageCropperComponent($scope, $element, $timeout, userMedia, $filter, deviceChecker) {
    var self = this;

    let aspectRatio = 1;

    var coverImageConfigs = {
        minCropBoxWidth: 1000,
        minCropBoxHeight: 400,
        containerWidth: 1000,
        containerHeight: 400,
        showPreview: false,
        aspectRatio: 2.5
    };

    const CSPCollageImageConfigs = {
        minCropBoxWidth: 1000,
        minCropBoxHeight: 666.67,
        containerWidth: 1000,
        containerHeight: 666.67,
        showPreview: false,
        aspectRatio: 1.5
    };

    var careerPortalCoverImageConfigs = {
        minCropBoxWidth: 1280,
        minCropBoxHeight: 310,
        containerWidth: 1000,
        containerHeight: 242,
        showPreview: false,
        aspectRatio: 4.129
    };

    var careerPortalSimpleViewCoverImageConfigs = {
        minCropBoxWidth: 1280,
        minCropBoxHeight: 800,
        containerWidth: 720,
        containerHeight: 450,
        showPreview: false,
        aspectRatio: 1.6
    };

    var jobCoverImageConfigs = {
        minCropBoxWidth: 1280,
        minCropBoxHeight: 500,
        containerWidth: 720,
        containerHeight: 281,
        showPreview: false,
        aspectRatio: 2.56
    };

    var offerHeaderImageConfigs = {
        minCropBoxWidth: 240,
        minCropBoxHeight: 240,
        containerWidth: 560,
        containerHeight: 560,
        showPreview: false
    };
    var profileImageConfigs = {
        minCropBoxWidth: 240,
        minCropBoxHeight: 240,
        containerWidth: 560,
        containerHeight: 560,
        showPreview: true,
        aspectRatio: 1
    };
    var RectangleProfileImageConfigs = {
        minCropBoxWidth: 250,
        minCropBoxHeight: 50,
        containerWidth: 560,
        containerHeight: 560,
        showPreview: true,
        aspectRatio: 5
    };

    var thumbnailImageConfigs = {
        minCropBoxWidth: 240,
        minCropBoxHeight: 240,
        containerWidth: 560,
        containerHeight: 560,
        showPreview: false,
    };

    var tlImageConfigs = {
        minCropBoxWidth: 800,
        minCropBoxHeight: 600,
        containerWidth: 560,
        containerHeight: 560,
        showPreview: true,
        showIpadPreview: true,
        aspectRatio: 1.333333333333333
    };

    const CSPImageConfigs = {
        minCropBoxWidth: 400,
        minCropBoxHeight: 200,
        containerWidth: 400,
        containerHeight: 200,
        showPreview: false,
        aspectRatio: 2,
    };

    // viewModeConfigs will contain one of the above configs according to the imageMode if 'cover' or 'profile'
    var viewModeConfigs = {};

    //store degrees as Int (0,1,2,3,-1,-2,-3);

    self.opt = {};
    self.modalContainerRef = $element.find('.image-cropping-modal');
    self.cropBoxRef = $element.find('.img-cropper-container>img');

    /**
     * Rotate
     *
     * @param degree
     * @param direction
     */
    self.rotate = function (degree) {
        self.cropBoxRef.cropper('rotate', degree);
    };

    /**
     * Zoom
     *
     * @param val
     */
    self.zoom = function (val) {
        self.cropBoxRef.cropper('zoom', val);
    };

    /**
     * Reset
     */
    self.reset = function () {
        self.cropBoxRef.cropper('reset');
    };

    /**
     * getCropingData
     *
     * @returns {{x1: Number, y1: Number, x2: number, y2: number, rotation: number}}
     */
    self.getCropingData = function () {

        var cropping_data = self.cropBoxRef.cropper('getData', true);

        var data = {
            'degrees': cropping_data.rotate,
            // Rotation is no longer used, as rotation is being done from the client side
            'rotation': (cropping_data.rotate / 90) * -1,
            'image_uuid': self.opt['image_uuid'],
        };

        return data;
    };

    /**
     * Save
     */
    self.save = function () {
        var image = self.cropBoxRef.cropper('getDataURL');

        var data = self.getCropingData();
        if (self.opt.crop) {
            let base64Data = self.cropBoxRef.cropper('getCroppedCanvas').toDataURL('image/' + self.extension);
            self.onSave({
                data: {
                    coords: data,
                    base64Data: base64Data,
                    image: MediaUtils.base64toBlob(base64Data, 'image/' + self.extension),
                }
            });
            self.close && self.close();
            userMedia.clearCache();
        } else {
            rotateBase64Image($(image).attr("src"), data.degrees, function (base64Data) {
                data.rotation = 0;
                data.degrees = 0;
                // Type is image/jpeg because it is a result of a rotate
                // TODO: Change it to read type from data
                self.onSave({
                    data: {
                        coords: data,
                        image: MediaUtils.base64toBlob(base64Data, 'image/' + self.extension),
                    }
                });

                self.close && self.close();
                userMedia.clearCache();
            });
        }

    };

    /**
     * Options validate
     *
     * @param opt
     */
    self.optValidate = function (opt) {
        if (!opt.hasOwnProperty('file')) {
            console.error('Image Cropping Modal: No option specified');
            return false;
        }
        return true;
    };

    // set image data
    self.setImageByData = function (file) {

        if (!file) {
            console.warn("Trying to set image data without a file");
            return;
        }
        self.extension = file.name.split('.').pop();

        var reader = new FileReader();
        reader.onload = function (evt) {

            var imageMaxSize = 8192;

            if (deviceChecker.isMobile()) {
                imageMaxSize = 2048;
            }

            loadImage.parseMetaData(
                file,
                function (data) {

                    var options = {
                        maxWidth: imageMaxSize,
                        maxHeight: imageMaxSize,
                        canvas: true
                    };

                    if (data.exif) {
                        options.orientation = data.exif.get('Orientation');
                    }

                    loadImage(
                        evt.target.result,
                        function (imgCanvas) {
                            self.initCropperPlugin(imgCanvas.toDataURL('image/' + self.extension));
                        },
                        options
                    );
                });

        };

        reader.onprogress = function (evt) {
            //console.log(evt)
        };

        reader.readAsDataURL(file);
    };

    /**
     * initCropper
     *
     * @param opt
     */
    self.initCropper = function (opt) {
        self.cropBoxRef.cropper('destroy');

        var options = {
            guides: false,
            aspectRatio: aspectRatio,
            preview: ".img-preview",
            // checkOrientation: false,
            viewMode: 1,
            zoomable: self.opt['zoomable'] ? true : false,
            minCropBoxHeight: opt['minCropBoxHeight'],
            minCropBoxWidth: opt['minCropBoxWidth']
        };

        self.cropBoxRef.cropper(options);
        if (opt['imageMode'] == "brand_offer_header") {
            self.cropBoxRef.cropper('setCropBoxData', opt['crop_dim']);
        }
    };

    /**
     * setCropData
     *
     * @param data
     */
    self.setCropData = function (data) {
        self.cropBoxRef.cropper({
            left: data.x1,
            top: data.y1,
            width: data.x2,
            height: data.y2
        });
    };


    const closeCropper = () => {
        self.close?.();
        self.cropBoxRef.cropper('destroy');
    };

    self.initCropperPlugin = function (img) {

        self.cropBoxRef.cropper('destroy');
        $element.find(".loader").show();

        setTimeout(function () {

            self.cropBoxRef.off("load").on("load", function () {

                const naturalWidth = self.cropBoxRef.width();
                const naturalHeight = self.cropBoxRef.height();

                if (
                    self.opt.minUploadedImageDimension?.width &&
                    self.opt.minUploadedImageDimension?.height &&
                    (
                        naturalWidth < self.opt.minUploadedImageDimension.width ||
                        naturalHeight < self.opt.minUploadedImageDimension.height
                    )
                ) {
                    hAlert(
                        $filter("translate")("The photo you uploaded is too small") + '!',
                        `${$filter("translate")("It must be at least")} ${self.opt.minUploadedImageDimension.width} ${$filter("translate")("pixels width and")} ${self.opt.minUploadedImageDimension.height} ${$filter("translate")("pixels height")}.`,
                        null,
                        "image-small-alert"
                    );
                    closeCropper();
                    return;
                }

                var interval = setInterval(function () {

                    if (!naturalWidth || !naturalHeight) {
                        return;
                    }

                    clearInterval(interval);

                    var width = $(window).width() - 30;
                    var height = $(window).height() - 100;

                    width = (width > viewModeConfigs['containerWidth']) ? viewModeConfigs['containerWidth'] : width;
                    height = (height > viewModeConfigs['containerHeight']) ? viewModeConfigs['containerHeight'] : height;

                    var criteria = (height < width) ? height : width;
                    const minCropBoxWidth = self.opt['minCropBoxWidth'] || viewModeConfigs['minCropBoxWidth'];
                    const minCropBoxHeight = self.opt['minCropBoxHeight'] || viewModeConfigs['minCropBoxHeight'];

                    self.opt['minCropBoxWidth'] = parseInt(Math.ceil((criteria / naturalWidth) * minCropBoxWidth));
                    self.opt['minCropBoxHeight'] = parseInt(Math.ceil((criteria / naturalHeight) * minCropBoxHeight));

                    self.minCropDim = self.opt['minCropDimension'] || Math.min(self.opt['minCropBoxWidth'], self.opt['minCropBoxHeight']);

                    self.opt['minCropBoxWidth'] = parseInt(Math.ceil(self.minCropDim * aspectRatio));
                    self.opt['minCropBoxHeight'] = parseInt(Math.ceil(self.minCropDim));

                    if (naturalWidth >= minCropBoxWidth && naturalHeight >= minCropBoxHeight) {

                        setTimeout(function () {
                            $(".img-cropper-container").css("height", criteria + "px");
                            // for the width attribute in the css with the value of 100% to take precedence for the loading gif to be centered
                            // $(".img-cropper-container").css("width", criteria + "px");

                            $element.find(".loader").hide();

                            self.initCropper(self.opt);
                        }, 100);

                    } else {
                        closeCropper();
                        hAlert(
                            $filter("translate")("The photo you uploaded is too small!"),
                            `${$filter("translate")("It must be at least")} ${minCropBoxWidth} ${$filter("translate")("pixels width and")} ${minCropBoxHeight} ${$filter("translate")("pixels height.")}`,
                            null,
                            "image-small-alert"
                        );
                    }

                }, 100);
            });


            if (img) {
                self.cropBoxRef.attr('src', img);
            } else if (self.opt['url']) {
                self.cropBoxRef.attr('src', self.opt['url']);
            }

        }, 1000);

        self.cropBoxRef.attr('src', '');
    };

    // Cropping images
    self.$postLink = function () {
        if (self.opt['imageMode'] === 'cover' || self.opt['imageMode'] === 'background_image') {
            viewModeConfigs = coverImageConfigs;
        } else if (self.opt['imageMode'] === 'career_portal_image') {
            viewModeConfigs = careerPortalCoverImageConfigs;
        } else if (self.opt['imageMode'] === 'career_portal_simple_view_image') {
            viewModeConfigs = careerPortalSimpleViewCoverImageConfigs;
        }else if (self.opt['imageMode'] === 'job_background_image') {
            viewModeConfigs = jobCoverImageConfigs;
        } else if (self.opt['imageMode'] === 'tlipad') {
            viewModeConfigs = tlImageConfigs;
        } else if (self.opt['imageMode'] === 'brand_offer_header') {
            viewModeConfigs = offerHeaderImageConfigs;
        } else if (self.opt['imageMode'] === 'thumbnail' || self.opt['imageMode'] === 'gallery_videos') {
            viewModeConfigs = thumbnailImageConfigs;
        } else if (self.opt['imageMode'] === 'rectangle_profile_image') {
            viewModeConfigs = RectangleProfileImageConfigs;
        } else if (self.opt['imageMode'] === 'csp_image') {
            viewModeConfigs = CSPImageConfigs;
        } else if (self.opt['imageMode'] === 'csp_image_collage') {
            viewModeConfigs = CSPCollageImageConfigs;
        } else {
            viewModeConfigs = profileImageConfigs;
        }
        self.showPreview = !self.opt['hidePreview'] && viewModeConfigs['showPreview'];
        self.showIpadPreview = viewModeConfigs['showIpadPreview'];
        aspectRatio = self.opt['aspectRatio'] || viewModeConfigs['aspectRatio'];

        var valid = self.optValidate(self.opt);
        if (!valid) {
            return false;
        }

        // load image from remote source
        if (self.opt['url']) {
            self.initCropperPlugin();
        } else {
            self.setImageByData(self.opt['file']);
        }

        if (self.opt['crop_dim']) {
            self.setCropData(self.opt['crop_dim']);
        }
    };

    self.$onDestroy = function () {
        self.cropBoxRef.cropper('destroy');
    }
}

angular
    .module('harriMainApp')
    .component("hImageCropper", {
        bindings: {
            opt: '=',
            onSave: '&',
            close: '&',
        },
        controller: HImageCropperComponent,
        controllerAs: '$ctrl',
        templateUrl: '../hmodules/harri-main/components/h-image-cropper/h-image-cropper.component.ng.html'
    });
